import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { BxBreadcrumb } from '@beyonnex/bx-angular-ui';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DeviceListGridComponent } from '../../components/device-list-grid/device-list-grid.component';
import { COLUMN_DEFS_STORAGE_KEY, GridPersistColumnDefsService } from '../../services/grid/grid-persist-column-defs.service';
import { GridPersistFiltersService } from '../../services/grid/grid-persist-filters.service';
import { GridPersistSortService } from '../../services/grid/grid-persist-sort.service';
import { ScreenSizeService } from '../../services/screen-size/screen-size.service';
import { PageComponent } from '../page/page.component';

@Component({
  selector: 'bxi-device-list',
  imports: [PageComponent, TranslatePipe, DeviceListGridComponent],
  providers: [
    GridPersistColumnDefsService,
    { provide: COLUMN_DEFS_STORAGE_KEY, useValue: 'deviceListColumnDefs' },
    GridPersistFiltersService,
    GridPersistSortService,
  ],
  templateUrl: './device-list.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceListComponent implements OnInit, OnDestroy {
  private readonly translate = inject(TranslateService);
  private readonly screenSize = inject(ScreenSizeService);

  protected readonly breadcrumbOptions = signal<BxBreadcrumb[]>([
    { label: this.translate.instant('navigation.devices'), route: '/devices' },
  ]);

  protected totalCount = signal<string>('');

  ngOnInit(): void {
    this.screenSize.setScreenSize('full');
  }

  ngOnDestroy(): void {
    this.screenSize.setScreenSize('regular');
  }

  protected handleTotalCountChange(totalCount: number | null): void {
    this.totalCount.set(totalCount !== null ? ` (${totalCount})` : '');
  }
}
